import { BasemapKeys } from '@advanced-mapping/pl-mapbox';

export enum PLMapboxMapIds {
    EXPLORE = 'exploreMapbox',
    HERO_MAP_PROPERTY = 'insights-compare-bar-map',
    HERO_MAP_CHAIN = 'chains-search-map',
    FAVORITE_PLACES = 'favorite-places-map',
    VISITOR_JOURNEY_ROUTES = 'visitor-journey-routes-map',
    AUDIENCE_PROFILE = 'audience-profile-map',
    TRADE_AREA = 'trade_area_heatmap_map',
    VISITORS_BY_ORIGIN = 'visitors-by-origin-map',
    TRAFFIC_VOLUME = 'traffic_volume_map',
    AUDIENCE_PROFILE_CHAIN = 'chains-audience-profile-map',
    MARKET_LANDSCAPE = 'market-landscape',
}

export const INITIAL_BASEMAP_BY_MAP_ID: Record<PLMapboxMapIds, BasemapKeys> = {
    [PLMapboxMapIds.EXPLORE]: 'esriStreets',
    [PLMapboxMapIds.HERO_MAP_PROPERTY]: 'esriStreets',
    [PLMapboxMapIds.HERO_MAP_CHAIN]: 'esriStreets',
    [PLMapboxMapIds.FAVORITE_PLACES]: 'esriStreets',
    [PLMapboxMapIds.VISITOR_JOURNEY_ROUTES]: 'esriStreets',
    [PLMapboxMapIds.AUDIENCE_PROFILE]: 'esriStreets',
    [PLMapboxMapIds.TRADE_AREA]: 'esriStreets',
    [PLMapboxMapIds.VISITORS_BY_ORIGIN]: 'esriHybrid',
    [PLMapboxMapIds.TRAFFIC_VOLUME]: 'esriHybrid',
    [PLMapboxMapIds.AUDIENCE_PROFILE_CHAIN]: 'esriStreets',
    [PLMapboxMapIds.MARKET_LANDSCAPE]: 'esriHybrid',
};

// Runtime check for uniqueness
const values = Object.values(PLMapboxMapIds);
const duplicates = values.filter((v, i, arr) => arr.indexOf(v) !== i);
if (duplicates.length) {
    throw new Error(`
        Duplicate PLMapboxMapIds found: ${[...new Set(duplicates)].join(', ')}. 
        PLMapbox cannot have duplicate mapId`);
}
